export enum HashAction {
  whyLabsMatter = "why-labs-matter"
}

export const HASH_ACTION_TRIGGER_CLASS = "hash-action-trigger";
